// src/services/analytics.js
export const GA_ID = 'G-HE9NC4XHGN';

/**
 * Send a custom GA4 event
 * @param {{ action: string, category: string, label?: string, value?: number, [key: string]: any }} params
 */
export function trackEvent(params) {
  if (typeof window === 'undefined' || !window.gtag) return;

  // Don’t track on localhost or in non-production builds
  const host = window.location.hostname;
  if (
    host === 'localhost' ||
    host === '127.0.0.1' ||
    process.env.NODE_ENV !== 'production'
  ) {
    return;
  }

  // Fire the event
  window.gtag('event', params.action, {
    event_category: params.category,
    event_label:    params.label,
    value:          params.value,
    ...params
  });
}
